import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/dashboard/general/')({
  component: () => <div>Hello /_layout/dashboard/general/!</div>,
})
